module.exports = "images/favicon-32x32.f1887f6736869e06806b8a34b40c9b2f.png";